export default __webpack_public_path__ + "static/media/logika-i-analitika.c116c318.gif";